import { GET_CUSTOMIZE_ORDER_FOR_ADMIN, GET_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS, GET_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR, UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN, UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS, UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR } from "./actionTypes"

const orders = {
    admin_clients: 'admin_clients',
    admin_analytics: 'admin_analytics',
    user_activity: 'user_activity'
}

const INIT_STATE = {
    orders: {
        [orders.admin_clients]: null,
        [orders.admin_analytics]: null,
        [orders.user_activity]: null,
    },
    admin_customize_order_loading: false,
    admin_customize_order_error: null,
}

const CustomizeOrderForAdmin = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZE_ORDER_FOR_ADMIN:
            return {
                ...state,
                admin_customize_order_loading: true,
                admin_customize_order_error: null,
            }
        case GET_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS:
            return {
                ...state,
                orders: action.payload,
                admin_customize_order_loading: false,
            }
        case GET_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR:
            return {
                ...state,
                admin_customize_order_error: action.payload,
                admin_customize_order_loading: false,
            }
        case UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN:
            return {
                ...state,
                admin_customize_order_loading: false
            }
        case UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_SUCCESS:
            return {
                ...state,
                orders: {
                    ...state.orders,
                    [action?.component]: action?.payload
                },
                admin_customize_order_loading: false
            }
        case UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN_ERROR:
            return {
                ...state,
                admin_customize_order_error: action.payload,
                admin_customize_order_loading: false
            }

        default:
            return state
    }

}

export default CustomizeOrderForAdmin;